<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            @searchResource="searchResource" 
            @create="()=>{newResource = {}; dialog = true;}"
          />
        </v-col>
        <v-col cols="12" CustomPageActions>
          <v-card class="px-3" :loading="loading">
            <v-row class="pa-0">
              <v-col cols="6">
                <v-btn block text color="success" :loading="loading" @click="syncEmailServer()"
                  :class="`${arabic?'arFont':'enFont'}`"
                >
                  <v-icon left>sync</v-icon>
                  SYNC EMAIL SERVER
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" Headers>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col cols="2" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  {{i18n.name}}
                </v-col>
                <v-col cols="2" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-left`">
                  {{i18n.agent}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.sent}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.opened}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.clicked}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.status}}
                </v-col>
                <v-col cols="3" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.viewIconTooltip}}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 mb-2 elevation-2 px-2 align-center py-3" 
                v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
                <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{r.type}}</span>
                    </template>
                    <div class="text-center">
                      <div :class="`${arabic?'arFont':'enFont'}`">
                        {{r.interview_company}} {{r.interview_program}} sent 
                        after {{r.delay}} {{r.delay_unit}} for {{r.interview_day}} at {{r.interview_time}}
                      </div>
                    </div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{r.template_name}}</span>
                    </template>
                    <div class="text-center">
                      <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.templates_id}}</div>
                    </div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{r.program}}</span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.program}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{r.program}}</span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.program}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{r.delay}}</span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.delay_unit}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{r.interview_day}}</span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.interview_time}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary" 
                        :disabled="r.sent || r.active_sending"
                        icon x-small @click.stop="()=>{
                        dialog = true
                        editing = true
                        newResource = r
                      }">
                        <v-icon>create</v-icon>
                      </v-btn>
                    </template>
                    <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                      {{i18n.editIconTooltip}}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="error" 
                        :disabled="r.sent || r.active_sending"
                        icon x-small @click.stop="()=>{
                        dialog = true
                        deleting = true
                        newResource = r
                      }">
                          <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span :class="`${arabic?'arFont':''} pa-0`">
                      {{i18n.deleteIconTooltip}}
                    </span>
                  </v-tooltip>
                </v-col>
                
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <multiDialog
          :dialog="dialog"
          :loading="loading"
          :resourceSettings="resourceSettings"
          :deleting="deleting"
          :resourceKeys="resourceKeys"
          :newResource="newResource"
          @closeDialog="()=>{dialog = false;newResource={};}"
          @deleteResource="deleteResource"
          @updateResource="updateResource"
          @postResource="postResource"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: { Search, Paging, multiDialog },
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        {name: 'type', label:'type', type:'select', items:'types', source:'local', data:['welcome', 'interviews'], required:true },
        {name: 'program', label:'program', type:'select', items:'programs', data:['ausbildung', 'jobs', 'nurses', 'engineers', 'students', 'doctors', 'tech', 'aramcco', 'aramcco_sprachlehrer', 'aramcco_de_mitarbeiter', 'aramcco_de_ga_mitarbeiter', 'ausbildung_seminar', 'tech_seminar', 'engineers_seminar', 'students_seminar', 'nurses_seminar', 'doctors_seminar', 'aramcco-leaders', 'aramcco_social_media', 'aramcco_public_relations', 'aramcco_asyut', 'aramcco_tagamo3', 'yemen'], source:'local',  required: true },
        {name: 'templates', label:'templates', type:'select', items:'templates', data:[], source:'db', required:true },
        {name: 'delay', label:'delay', type:'text', required: true },
        {name: 'delay_unit', label:'delay_unit', type:'select', items:'units', source:'local', data:['hour', 'day'], required:true },
      ],
      resourceSettings:{
        resourceName:null,
        search:true,
        create:true,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      interviews:[],
      templates:[],
      lists:[],
      types:[],
      units:[]
    }
  },
  
  methods: {
    async syncEmailServer(){
      this.loading = true
      let b = await axios.get('https://aramcogermany.com/api/v1/syn-email-system').then(x=>x.data)
      console.log(b)
      this.loading = false
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.resourceKeys.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = await this.$store.dispatch('loadAllResource', {resource:`/${f.items}auto`})
            let maps = t.map(x=>{
              let t = x.name?x.name:x.company?x.company:x.country?x.country:x.program?x.program:null
              console.log(t)
              return{...x, text:t, [`${f.items}_id`]:x.id}
            })
            f.data = maps
          }
          res(true)
        })()
      })
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}`})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource:this.$route.path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    }
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    await this.loadItems()
    this.setResourceName()
    await this.loadResource()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>